export default __webpack_public_path__ + "static/media/Box_4_Leaderboards.3a2b7de7.png";